import { ReactElement } from 'react';

import { IRouteOptions } from '@app/src/common/constants/routeUrls';

import { IExternalModule, ISidebarRoute } from './constants/navigationRoutes';

// One entry of the module menu, rendered identically by the sidebar and the Module Selector.
// Internal modules carry a react-router `path`; external ones carry a `navigate` handoff instead.
export interface IModuleEntry {
  key: string;
  labelId: string;
  Icon: () => ReactElement;
  order: number;
  path?: string;
  navigate?: () => void;
}

// Merges the routes the user may access with the visible external modules into a single ordered menu.
// Kept free of store imports so it stays testable in isolation.
export function buildModuleEntries(
  routes: IRouteOptions[],
  sidebarRoutes: Record<string, ISidebarRoute>,
  externalModules: IExternalModule[]
): IModuleEntry[] {
  const internalEntries: IModuleEntry[] = routes
    .filter(route => route.navigationRoute && sidebarRoutes[route.path])
    .map(route => ({
      ...sidebarRoutes[route.path],
      key: route.path,
      path: route.path
    }));

  const externalEntries: IModuleEntry[] = externalModules
    .filter(module => module.isVisible())
    .map(module => ({
      key: module.key,
      labelId: module.labelId,
      Icon: module.Icon,
      order: module.order,
      navigate: module.navigate
    }));

  return [...internalEntries, ...externalEntries].sort(
    (a, b) => a.order - b.order
  );
}
